const DesignFacade = require('../../facade/design/design');
const FormatFactory = require('../../factory/formats');
const UserInfoFactory = require('../../factory/user-info');
const AnalyticsDecorate = require('../../analytics/decorate');
const RestrictDecorate = require('../../facade/restrictions/decorate');

module.exports = RestrictDecorate(require('./restrict/size'), AnalyticsDecorate(require('./analytics/size'), Backbone.mixin(Backbone.View.extend({
  template: require('./template-size.hbs'),
  events: {
    'change [name=page-size]': 'togglePageSizeEvent',
    'change [type=checkbox]': 'toggleCheckBoxEvent',
    'click .formats-container.upgrade': 'toggleCheckBoxEvent',
    'change select.unit': 'sizeChangeEvent',
    'change input.size': 'inputChangeEvent',
    'click .do-resize': 'doResizeEvent'
  },

  showResizeMenu: function (event) {
    const $menu = this.$el.find('section.format');
    $menu.toggleClass('active');
  },

  showResizeEvent: function (event) {
    this.fieldModified = false;
    this.$el.find('[type=checkbox]').attr('checked', false);
    this.$el.find('.do-resize').addClass('disabled');
    this.$el.find('select.unit').addClass('disabled');
    this.$el.find('input.size').addClass('disabled');

    this.$el.find('.page-size-group .disabled').prop('disabled', true);

    this.$el.find('.ui-dropdown-content').css('left', event.currentTarget.getBoundingClientRect().x);

    const $content = this.$el.find('.ui-dropdown-content');

    this.resetCustomSize();
    if ($(event.currentTarget).is('.active')) {
      $content.show();
    } else {
      $content.hide();
    }
  },

  inputChangeEvent: function () {
    this.fieldModified = true;
  },

  togglePageSizeEvent: function (event) {
    const $customButton = this.$el.find('input.custom');

    const isCustom = $customButton.is(':checked');
    this.$el.find('input.size').toggleClass('disabled', !isCustom);
    this.$el.find('select.unit').toggleClass('disabled', !isCustom);
    this.$el.find('a.do-resize').toggleClass('disabled', !isCustom);

    this.$el.find('input.size').prop('disabled', !isCustom);
    this.$el.find('select.unit').prop('disabled', !isCustom);
    this.$el.find('a.do-resize').prop('disabled', !isCustom);

    isCustom && this.resetCustomSize();
  },

  resetCustomSize: function () {
    const size = FormatFactory.getCurrentSize();
    const defaultHeight = size.height || 100;
    const defaultWidth = size.width || 100;
    const unit = size.unit || 'px';

    this.$el.find('input.page-width').val(defaultWidth);
    this.$el.find('input.page-height').val(defaultHeight);
    this.$el.find('select.unit').val(unit);
  },

  toggleCheckBoxEvent: function (event) {
    const $target = $(event.currentTarget);

    if (!this.isProUser && $target.parents('.default-formats').length) {
      $target.prop('checked', false);
      INKIVE.Helpers.displaySubscriptionModal();
    }

    const $checkBox = this.$el.find('input[type=checkbox]');
    const isCheck = $checkBox.is(':checked');

    this.$el.find('a.do-resize').toggleClass('disabled', !isCheck);
  },

  sizeChangeEvent: function () {
    if (this.fieldModified) {
      return;
    }
    const limitLow = 40;
    const limitHight = 5000;
    const pixel2unit = INKIVE.Helpers.convertPixelsToUnits;
    const unit2pixel = INKIVE.Helpers.convertUnitsToPixels;
    const newUnit = this.$el.find('select.unit').val();
    const previousUnit = FormatFactory.getCurrentSize().unit || 'px';

    if (previousUnit === newUnit) {
      return;
    }

    this.$el.find('input.size').each(function () {
      let val = $(this).val();

      const valueInPixels = unit2pixel(val, previousUnit);

      if (valueInPixels > limitHight) {
        val = pixel2unit(limitHight, newUnit);
      } else if (valueInPixels < limitLow) {
        val = pixel2unit(limitLow, newUnit);
      } else {
        val = pixel2unit(valueInPixels, newUnit);
      }

      $(this).val(Math.round(val * 100) / 100);
    });
  },

  doResizeEvent: function () {
    const doResize = require('./resize');
    doResize.call(this);
  },

  initialize: function () {
    _.bindAll(this, 'render', 'updateCurrentPageInfo', 'sizeChangeEvent');

    this.tool = INKIVE.Tool.getInstance();
    this.editor = this.tool.editor;
    DesignFacade.on('template.update.size', this.updateCurrentPageInfo);
    DesignFacade.on('template.update.designed', this.updateCurrentPageInfo);
    DesignFacade.on('template.update.restricted', this.updateCurrentPageInfo);
    $(document).bind('contextmenu', (e) => this.prependFormatToFileMenu(e));
  },

  render: function (format, groups, printableFormats) {
    const units = _.uniq(_.pluck(_.flatten(_.pluck(groups, 'data')), 'unit'));
    const size = FormatFactory.getCurrentSize();

    if (size.width !== format.width || 'size'.height !== format.size || size.unit !== format.unit) {
      format = size;
    }

    format.unit = format.unit || 'px';
    format.name = format.name || INKIVE.TranslateHelper.translate('bottom_submenu.size.custom');

    this.editor.canvas.runExtensions('updateUnits', format.unit);

    this.format = format;

    this.$el.html(this.template({
      format,
      groups,
      units,
      printable_formats: printableFormats,
      is_free_user: !this.isProUser
    }));

    this.$el.find(('.desygner-group-name-header:not(:has(+  .checkbox-container  ul  .filter-line  .desygner-custom-check  label))')).remove();
    printableFormats.length || this.$el.find('.popular-formats').hide();
    INKIVE.Helpers.initTooltips(this.$el);

    this.trigger('render');

    const formatElement = this.createFormatElement();
    const checkboxContainer = document.querySelector('.page-size-group .checkbox-container > ul');
    if (checkboxContainer) checkboxContainer.append(formatElement);
  },

  createFormatElement: function () {
    const formatPopupTitle = INKIVE.TranslateHelper.translate('bottom_submenu.size.format');
    const formatTitle = INKIVE.TranslateHelper.translate('bottom_submenu.size.format_title');
    const { width, height, unit } = FormatFactory.getCurrentSize();
    const format = `${Math.precision(width, 2)} × ${Math.precision(height, 2)} ${unit}`;

    const div = document.createElement('div');
    div.innerHTML = `
      <li class="page-size" data-popover="tooltip" data-placement="top"
        data-original-title="${formatPopupTitle}">
        <span>${formatTitle}: ${format}</span>
      </li>
    `.trim();

    return div.firstChild;
  },

  prependFormatToFileMenu: function (e) {
    const isFileMenu = e.target.dataset.action === 'file';
    if (!isFileMenu) return;

    const formatElement = this.createFormatElement();
    const contextMenu = document.querySelector('.context-menu-root');
    if (contextMenu && !contextMenu.querySelector('.page-size')) contextMenu.append(formatElement);
  },

  updateCurrentPageInfo: function (data) {
    const currentFormatPromise = FormatFactory.getCurrentFormat();
    const groupsPromise = FormatFactory.getGroups();
    const printableFormatsPromise = FormatFactory.getPrintableFormats();
    const userInfoPromise = UserInfoFactory.get();

    Promise.all([
      currentFormatPromise,
      groupsPromise,
      printableFormatsPromise,
      userInfoPromise,
    ]).then(([currentFormat, groups, printableFormats, userInfo]) => {
      if (data?.size) {
        currentFormat = data.size;
      }

      this.currentCanvasProperties = currentFormat;
      this.isProUser = _(userInfo.roles).contains('ROLE_PRO');
      this.filterGroups(groups);
      this.render(currentFormat, groups, printableFormats);
    }).catch((error) => {
      this.trigger('render');
    });
  },

  filterGroups: function (groups) {
    _.each(groups, (g) => _.map(g.data, (f) => {
      if (f.total_drafts === f.total_templates) f.hidden = true;
    }));
  }
}), Backbone.Events)));
